var angular = require('angular');
var template = require('./publicInformation.pug');

 angular.module("app.directives").directive('publicInformation', function () {
  return {
    restrict: 'E',
    replace: true,
    template: template,
  }
});
